import { CheckCircle, Mail, FileText, CreditCard, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function RegistrationSuccess({ data, onClose }) {
  const handlePayPal = () => {
    if (data.paypal_link) {
      window.open(data.paypal_link, "_blank");
    }
  };

  return (
    <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-[#0A0A0A] border border-white/10 rounded-xl w-full max-w-lg p-8 text-center">
        {/* Success Icon */}
        <div className="w-20 h-20 bg-[#c1ff72]/20 rounded-full flex items-center justify-center mx-auto mb-6">
          <CheckCircle className="w-10 h-10 text-[#c1ff72]" />
        </div>
        
        {/* Title */}
        <h2 className="font-['Bebas_Neue'] text-4xl text-white mb-2">
          Anmeldung erfolgreich!
        </h2>
        
        <p className="text-white/60 mb-6">
          Vielen Dank für deine Anmeldung zur Next Level Fussball Akademie.
        </p>
        
        {/* Registration Details */}
        <div className="bg-[#1A1A1A] rounded-lg p-6 mb-6 text-left">
          <div className="space-y-3">
            <div className="flex justify-between">
              <span className="text-white/60">Vertragsnummer</span>
              <span className="text-[#c1ff72] font-mono">{data.registration_id}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-white/60">Monatsbeitrag</span>
              <span className="text-white font-bold">{data.contract_price}€</span>
            </div>
            {data.is_early_bird && (
              <div className="flex justify-between">
                <span className="text-white/60">Frühbucher-Rabatt</span>
                <span className="text-[#c1ff72]">✓ Angewendet!</span>
              </div>
            )}
          </div>
        </div>
        
        {/* What happens next */}
        <div className="text-left mb-6">
          <h3 className="text-white font-medium mb-3">Nächste Schritte:</h3>
          <div className="space-y-3">
            <div className="flex items-start gap-3">
              <Mail className="w-5 h-5 text-[#c1ff72] mt-0.5 flex-shrink-0" />
              <p className="text-white/70 text-sm">
                Du erhältst in Kürze eine E-Mail mit der Bestätigung und dem Vertrag als PDF.
              </p>
            </div>
            <div className="flex items-start gap-3">
              <FileText className="w-5 h-5 text-[#c1ff72] mt-0.5 flex-shrink-0" />
              <p className="text-white/70 text-sm">
                Bitte prüfe den Vertrag und bewahre ihn für deine Unterlagen auf.
              </p>
            </div>
            {data.paypal_link && (
              <div className="flex items-start gap-3">
                <CreditCard className="w-5 h-5 text-[#c1ff72] mt-0.5 flex-shrink-0" />
                <p className="text-white/70 text-sm">
                  Schließe die Zahlung über PayPal ab, um die Anmeldung zu bestätigen.
                </p>
              </div>
            )}
          </div>
        </div>
        
        {/* Action Buttons */}
        <div className="space-y-3">
          {data.paypal_link && (
            <Button
              onClick={handlePayPal}
              className="w-full bg-[#0070ba] hover:bg-[#003087] text-white font-bold py-6"
            >
              Jetzt mit PayPal bezahlen
              <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          )}
          
          <Button
            onClick={onClose}
            variant="outline"
            className="w-full border-white/20 text-white hover:bg-white/10"
          >
            Schließen
          </Button>
        </div>
        
        {/* Contact Info */}
        <p className="text-white/40 text-sm mt-6">
          Bei Fragen erreichst du uns unter kontakt@fussballtraining-aktas.de
        </p>
      </div>
    </div>
  );
}
